define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_card/validate_transfer_funds_form",

        validation: {
            name_on_card: {
                required: true
            },
            mt4_account_no: {
                required: true,
                min: 10000
            },
            amount: {
                required: true,
                pattern: 'number',
                min: 1
            },
            amount_hkd:{
                required: true,
                pattern: 'number',
                min: 500
            },
            card_third: {
                required: true,
                length: 4,
                pattern: 'digits'
            },
            card_fourth: {
                required: true,
                length: 4,
                pattern: 'digits'
            }
        }
    });
});
